import { ErrorStateVariant } from "@/components/errorState/types";
import { RenderError } from "@/types/defs/errorState";
import { isNetworkError } from "@/utils/typeGuards/isNetworkError";

// Decides which error screen to show from signals available client-side, checked in order: the user's connection is down → we were unreachable → we broke (the catch-all; the reference chip is shown only when the error carries a server digest).
export const classifyRenderError = (
  error: RenderError,
  isOnline: boolean
): ErrorStateVariant => {
  if (!isOnline) {
    return "offline";
  }
  if (isNetworkError(error)) {
    return "connection";
  }
  return "server";
};
